import { render, staticRenderFns } from "./DataPolicyPage.html?vue&type=template&id=88bc10d8&scoped=true&"
import script from "./DataPolicyPage.js?vue&type=script&lang=js&"
export * from "./DataPolicyPage.js?vue&type=script&lang=js&"
import style0 from "./DataPolicyPage.scss?vue&type=style&index=0&id=88bc10d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bc10d8",
  null
  
)

export default component.exports